module.exports = __webpack_public_path__ + "media/images/captive_portal/Upload-btn-2d0603537809a923188ee3b09716daee.svg";